/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: kx7Qgd3B-3Xa

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import * as pp from "@plasmicapp/react-web";
import { StateProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/StateProvider/StateProvider"; // plasmic-import: OaGu0RHjgthJ/codeComponent
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicTextInput.module.css"; // plasmic-import: kx7Qgd3B-3Xa/css

import SearchSvgIcon from "./icons/PlasmicIcon__SearchSvg"; // plasmic-import: 4h8B6qj-XIZa/icon
import UnionSvgIcon from "./icons/PlasmicIcon__UnionSvg"; // plasmic-import: cK8gX6ST96pT/icon
import VectorSvg2Icon from "./icons/PlasmicIcon__VectorSvg2"; // plasmic-import: ZSI55Wkxal7b/icon

createPlasmicElementProxy;

export type PlasmicTextInput__VariantMembers = {
  showStartIcon: "showStartIcon";
  showEndIcon: "showEndIcon";
  isDisabled: "isDisabled";
  invalid: "invalid";
  size: "small" | "medium" | "large";
  showPrefix: "showPrefix";
};
export type PlasmicTextInput__VariantsArgs = {
  showStartIcon?: SingleBooleanChoiceArg<"showStartIcon">;
  showEndIcon?: SingleBooleanChoiceArg<"showEndIcon">;
  isDisabled?: SingleBooleanChoiceArg<"isDisabled">;
  invalid?: SingleBooleanChoiceArg<"invalid">;
  size?: SingleChoiceArg<"small" | "medium" | "large">;
  showPrefix?: SingleBooleanChoiceArg<"showPrefix">;
};
type VariantPropType = keyof PlasmicTextInput__VariantsArgs;
export const PlasmicTextInput__VariantProps = new Array<VariantPropType>(
  "showStartIcon",
  "showEndIcon",
  "isDisabled",
  "invalid",
  "size",
  "showPrefix"
);

export type PlasmicTextInput__ArgsType = {
  placeholder?: string;
  startIcon?: React.ReactNode;
  value?: string;
  name?: string;
  required?: boolean;
  "aria-label"?: string;
  "aria-labelledby"?: string;
  onChange?: (event: any) => void;
  type?:
    | "text"
    | "password"
    | "hidden"
    | "number"
    | "date"
    | "datetime-local"
    | "time"
    | "email"
    | "tel";
  autoFocus?: boolean;
  autoComplete?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  inputMode?: string;
};
type ArgPropType = keyof PlasmicTextInput__ArgsType;
export const PlasmicTextInput__ArgProps = new Array<ArgPropType>(
  "placeholder",
  "startIcon",
  "value",
  "name",
  "required",
  "aria-label",
  "aria-labelledby",
  "onChange",
  "type",
  "autoFocus",
  "autoComplete",
  "onBlur",
  "onFocus",
  "inputMode"
);

export type PlasmicTextInput__OverridesType = {
  root?: Flex__<"div">;
  inputType?: Flex__<typeof StateProvider>;
  startIconContainer?: Flex__<"button">;
  text?: Flex__<"div">;
  input?: Flex__<"input">;
  endIconContainer?: Flex__<"div">;
  hidePasswordIcon?: Flex__<"svg">;
  showPasswordIcon?: Flex__<"svg">;
};

export interface DefaultTextInputProps extends pp.BaseTextInputProps {
  placeholder?: string;
  value?: string;
  name?: string;
  required?: boolean;
  "aria-label"?: string;
  "aria-labelledby"?: string;
  onChange?: (event: any) => void;
  type?:
    | "text"
    | "password"
    | "hidden"
    | "number"
    | "date"
    | "datetime-local"
    | "time"
    | "email"
    | "tel";
  autoFocus?: boolean;
  autoComplete?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  inputMode?: string;
  invalid?: SingleBooleanChoiceArg<"invalid">;
  size?: SingleChoiceArg<"small" | "medium" | "large">;
  showPrefix?: SingleBooleanChoiceArg<"showPrefix">;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicTextInput__RenderFunc(props: {
  variants: PlasmicTextInput__VariantsArgs;
  args: PlasmicTextInput__ArgsType;
  overrides: PlasmicTextInput__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          placeholder: "Text",
          autoComplete: "on"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "showStartIcon",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.showStartIcon
      },
      {
        path: "showEndIcon",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.showEndIcon
      },
      {
        path: "isDisabled",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isDisabled
      },
      {
        path: "value",
        type: "writable",
        variableType: "text",

        valueProp: "value",
        onChangeProp: "onChange"
      },
      {
        path: "invalid",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.invalid
      },
      {
        path: "size",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.size
      },
      {
        path: "inputType.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "showPrefix",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.showPrefix
      }
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootinvalid]: hasVariant($state, "invalid", "invalid"),
          [sty.rootisDisabled]: hasVariant($state, "isDisabled", "isDisabled"),
          [sty.rootshowEndIcon]: hasVariant(
            $state,
            "showEndIcon",
            "showEndIcon"
          ),
          [sty.rootshowPrefix]: hasVariant($state, "showPrefix", "showPrefix"),
          [sty.rootshowStartIcon]: hasVariant(
            $state,
            "showStartIcon",
            "showStartIcon"
          ),
          [sty.rootsize_large]: hasVariant($state, "size", "large"),
          [sty.rootsize_medium]: hasVariant($state, "size", "medium"),
          [sty.rootsize_small]: hasVariant($state, "size", "small")
        }
      )}
      style={{ padding: 0 }}
    >
      <StateProvider
        data-plasmic-name={"inputType"}
        data-plasmic-override={overrides.inputType}
        defaultValue={(() => {
          try {
            return $props.type;
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        onChange={async (...eventArgs: any) => {
          generateStateOnChangeProp($state, ["inputType", "value"]).apply(
            null,
            eventArgs
          );
        }}
        value={generateStateValueProp($state, ["inputType", "value"])}
      />

      <button
        data-plasmic-name={"startIconContainer"}
        data-plasmic-override={overrides.startIconContainer}
        className={classNames(
          "all",
          "button",
          "button__bvRZj",
          sty.startIconContainer,
          {
            [sty.startIconContainerisDisabled]: hasVariant(
              $state,
              "isDisabled",
              "isDisabled"
            ),
            [sty.startIconContainershowEndIcon]: hasVariant(
              $state,
              "showEndIcon",
              "showEndIcon"
            ),
            [sty.startIconContainershowStartIcon]: hasVariant(
              $state,
              "showStartIcon",
              "showStartIcon"
            )
          }
        )}
        ref={ref => {
          $refs["startIconContainer"] = ref;
        }}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <SearchSvgIcon
              className={classNames("all", sty.svg__cuiG8)}
              role={"img"}
            />
          ),

          value: args.startIcon,
          className: classNames(sty.slotTargetStartIcon, {
            [sty.slotTargetStartIconshowStartIcon]: hasVariant(
              $state,
              "showStartIcon",
              "showStartIcon"
            )
          })
        })}
      </button>
      <div
        data-plasmic-name={"text"}
        data-plasmic-override={overrides.text}
        className={classNames("all", "__wab_text", sty.text, {
          [sty.textshowPrefix]: hasVariant($state, "showPrefix", "showPrefix")
        })}
      >
        {"+1"}
      </div>
      <input
        data-plasmic-name={"input"}
        data-plasmic-override={overrides.input}
        aria-label={args["aria-label"]}
        aria-labelledby={args["aria-labelledby"]}
        autoComplete={args.autoComplete}
        autoFocus={args.autoFocus}
        className={classNames("all", "input", "input__bvRZj", sty.input, {
          [sty.inputinvalid]: hasVariant($state, "invalid", "invalid"),
          [sty.inputisDisabled]: hasVariant($state, "isDisabled", "isDisabled"),
          [sty.inputshowEndIcon]: hasVariant(
            $state,
            "showEndIcon",
            "showEndIcon"
          ),
          [sty.inputshowPrefix]: hasVariant($state, "showPrefix", "showPrefix"),
          [sty.inputshowStartIcon]: hasVariant(
            $state,
            "showStartIcon",
            "showStartIcon"
          ),
          [sty.inputsize_large]: hasVariant($state, "size", "large"),
          [sty.inputsize_medium]: hasVariant($state, "size", "medium"),
          [sty.inputsize_small]: hasVariant($state, "size", "small")
        })}
        inputMode={args.inputMode}
        name={args.name}
        onBlur={async event => {
          const $steps = {};

          $steps["runOnBlur"] = true
            ? (() => {
                const actionArgs = { eventRef: $props["onBlur"] };
                return (({ eventRef, args }) => {
                  return eventRef?.(...(args ?? []));
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["runOnBlur"] != null &&
            typeof $steps["runOnBlur"] === "object" &&
            typeof $steps["runOnBlur"].then === "function"
          ) {
            $steps["runOnBlur"] = await $steps["runOnBlur"];
          }
        }}
        onFocus={async event => {
          const $steps = {};

          $steps["runOnFocus"] = true
            ? (() => {
                const actionArgs = { eventRef: $props["onFocus"] };
                return (({ eventRef, args }) => {
                  return eventRef?.(...(args ?? []));
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["runOnFocus"] != null &&
            typeof $steps["runOnFocus"] === "object" &&
            typeof $steps["runOnFocus"].then === "function"
          ) {
            $steps["runOnFocus"] = await $steps["runOnFocus"];
          }
        }}
        placeholder={args.placeholder}
        ref={ref => {
          $refs["input"] = ref;
        }}
        required={args.required}
        type={
          hasVariant($state, "showEndIcon", "showEndIcon")
            ? (() => {
                try {
                  return $state.inputType.value;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()
            : $state.inputType.value
        }
        value={args.value}
      />

      <div
        data-plasmic-name={"endIconContainer"}
        data-plasmic-override={overrides.endIconContainer}
        aria-label={"Toggle password visibility"}
        className={classNames("all", sty.endIconContainer, {
          [sty.endIconContainershowEndIcon]: hasVariant(
            $state,
            "showEndIcon",
            "showEndIcon"
          )
        })}
        title={"Toggle password visibility"}
      >
        {(
          hasVariant($state, "showEndIcon", "showEndIcon")
            ? (() => {
                try {
                  return $state.inputType.value === "text";
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return false;
                  }
                  throw e;
                }
              })()
            : true
        ) ? (
          <UnionSvgIcon
            data-plasmic-name={"hidePasswordIcon"}
            data-plasmic-override={overrides.hidePasswordIcon}
            aria-label={"Hide password"}
            className={classNames("all", sty.hidePasswordIcon, {
              [sty.hidePasswordIconshowEndIcon]: hasVariant(
                $state,
                "showEndIcon",
                "showEndIcon"
              )
            })}
            onClick={async event => {
              const $steps = {};

              $steps["updateInputTypeValue"] = true
                ? (() => {
                    const actionArgs = {
                      variable: {
                        objRoot: $state,
                        variablePath: ["inputType", "value"]
                      },
                      operation: 0,
                      value: "password"
                    };
                    return (({ variable, value, startIndex, deleteCount }) => {
                      if (!variable) {
                        return;
                      }
                      const { objRoot, variablePath } = variable;

                      $stateSet(objRoot, variablePath, value);
                      return value;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateInputTypeValue"] != null &&
                typeof $steps["updateInputTypeValue"] === "object" &&
                typeof $steps["updateInputTypeValue"].then === "function"
              ) {
                $steps["updateInputTypeValue"] =
                  await $steps["updateInputTypeValue"];
              }
            }}
            role={"img"}
          />
        ) : null}
        {(
          hasVariant($state, "showEndIcon", "showEndIcon")
            ? (() => {
                try {
                  return $state.inputType.value === "password";
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return false;
                  }
                  throw e;
                }
              })()
            : (() => {
                try {
                  return $state.inputType.value === "text";
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return false;
                  }
                  throw e;
                }
              })()
        ) ? (
          <VectorSvg2Icon
            data-plasmic-name={"showPasswordIcon"}
            data-plasmic-override={overrides.showPasswordIcon}
            aria-label={"Show password"}
            className={classNames("all", sty.showPasswordIcon, {
              [sty.showPasswordIconshowEndIcon]: hasVariant(
                $state,
                "showEndIcon",
                "showEndIcon"
              )
            })}
            onClick={async event => {
              const $steps = {};

              $steps["updateInputTypeValue"] = true
                ? (() => {
                    const actionArgs = {
                      variable: {
                        objRoot: $state,
                        variablePath: ["inputType", "value"]
                      },
                      operation: 0,
                      value: "text"
                    };
                    return (({ variable, value, startIndex, deleteCount }) => {
                      if (!variable) {
                        return;
                      }
                      const { objRoot, variablePath } = variable;

                      $stateSet(objRoot, variablePath, value);
                      return value;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateInputTypeValue"] != null &&
                typeof $steps["updateInputTypeValue"] === "object" &&
                typeof $steps["updateInputTypeValue"].then === "function"
              ) {
                $steps["updateInputTypeValue"] =
                  await $steps["updateInputTypeValue"];
              }
            }}
            role={"img"}
          />
        ) : null}
      </div>
    </div>
  ) as React.ReactElement | null;
}

function useBehavior<P extends pp.PlumeTextInputProps>(
  props: P,
  ref: pp.TextInputRef
) {
  return pp.useTextInput<P, typeof PlasmicTextInput>(
    PlasmicTextInput,
    props,
    {
      showStartIconVariant: {
        group: "showStartIcon",
        variant: "showStartIcon"
      },
      showEndIconVariant: { group: "showEndIcon", variant: "showEndIcon" },
      isDisabledVariant: { group: "isDisabled", variant: "isDisabled" },
      startIconSlot: "startIcon",
      endIconSlot: "endIcon",
      root: "root",
      input: "input"
    },
    ref
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "inputType",
    "startIconContainer",
    "text",
    "input",
    "endIconContainer",
    "hidePasswordIcon",
    "showPasswordIcon"
  ],
  inputType: ["inputType"],
  startIconContainer: ["startIconContainer"],
  text: ["text"],
  input: ["input"],
  endIconContainer: [
    "endIconContainer",
    "hidePasswordIcon",
    "showPasswordIcon"
  ],
  hidePasswordIcon: ["hidePasswordIcon"],
  showPasswordIcon: ["showPasswordIcon"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  inputType: typeof StateProvider;
  startIconContainer: "button";
  text: "div";
  input: "input";
  endIconContainer: "div";
  hidePasswordIcon: "svg";
  showPasswordIcon: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTextInput__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTextInput__VariantsArgs;
    args?: PlasmicTextInput__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicTextInput__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicTextInput__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTextInput__ArgProps,
          internalVariantPropNames: PlasmicTextInput__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTextInput__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTextInput";
  } else {
    func.displayName = `PlasmicTextInput.${nodeName}`;
  }
  return func;
}

export const PlasmicTextInput = Object.assign(
  // Top-level PlasmicTextInput renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    inputType: makeNodeComponent("inputType"),
    startIconContainer: makeNodeComponent("startIconContainer"),
    text: makeNodeComponent("text"),
    input: makeNodeComponent("input"),
    endIconContainer: makeNodeComponent("endIconContainer"),
    hidePasswordIcon: makeNodeComponent("hidePasswordIcon"),
    showPasswordIcon: makeNodeComponent("showPasswordIcon"),

    // Metadata about props expected for PlasmicTextInput
    internalVariantProps: PlasmicTextInput__VariantProps,
    internalArgProps: PlasmicTextInput__ArgProps,

    useBehavior
  }
);

export default PlasmicTextInput;
/* prettier-ignore-end */
